import { Formatters, Messages } from '../../codegen/Localize';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { L10n } from '../../ts/L10n/L10n';
import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { Set } from '../../ts/models/Set';
import { IServerUser } from '../../ts/ServerApi/types/IServerUser';
import { IUserActionResult } from '../../ts/ServerApi/types/IUserActionResult';
import { UserActionNotification, UserActionNotificationParams } from './notifications/UserActionNotification';
import { ServerUsers } from './resources/ServerUsers';
import { SiteUsers } from './resources/SiteUsers';

function showRemoveUsersFromSiteDialog(siteUsersToRemove: Set<ISiteUserInfo>): Promise<any> {

  const SessionManagementService = getSessionManagementServiceInstance();
  const userActionNotification: UserActionNotification = UserActionNotification.instance;

  const siteUserDisplayText = Messages.confirmRemoveUsersFromSite({
    USER_NAME: L10n.elideIfLong(siteUsersToRemove.first().displayName),
    USER_COUNT: siteUsersToRemove.size(),
    SITE_NAME: L10n.elideIfLong(SessionManagementService.sessionSiteName()),
    USER_COUNT_LOC: Formatters.formatCount(siteUsersToRemove.size())
  });

  const dialogInstance = openReactConfirmationDialog<void, IUserActionResult>({
    title: Messages.removeUser(),
    message: siteUserDisplayText,
    paramsForAction: undefined,
    actionName: Messages.removeUserAction({ITEM_COUNT: siteUsersToRemove.size()}),
    action: () => SiteUsers.instance.deleteUsers(siteUsersToRemove.keys()),
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IUserActionResult) => {
    const params: UserActionNotificationParams = {
      users: siteUsersToRemove,
      results: result.results,
      errors: result.errors,
      successCode: '13',
    };
    userActionNotification.notify(params);
  });

  return dialogInstance.result;
}

function showDeleteUsersFromServerDialog(serverUsersToRemove: Set<IServerUser>): Promise<any> {

  const userActionNotification = UserActionNotification.instance;

  const serverUserDisplayText = Messages.confirmDeleteUsers({
    USER_NAME: L10n.elideIfLong(serverUsersToRemove.first().displayName),
    USER_COUNT: serverUsersToRemove.size(),
    USER_COUNT_LOC: Formatters.formatCount(serverUsersToRemove.size())
  });

  const dialogInstance = openReactConfirmationDialog<void, IUserActionResult>({
    title: Messages.removeUser(),
    message: serverUserDisplayText,
    paramsForAction: undefined,
    actionName: Messages.removeUserAction({ITEM_COUNT: serverUsersToRemove.size()}),
    action: () => ServerUsers.instance.deleteUsers(serverUsersToRemove.keys()),
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IUserActionResult) => {
    const params: UserActionNotificationParams = {
      users: serverUsersToRemove,
      results: result.results,
      errors: result.errors,
      successCode: '11',
    };
    userActionNotification.notify(params);
  });

  return dialogInstance.result;
}

export const RemoveUsersAction = {
  showRemoveUsersFromSiteDialog,
  showDeleteUsersFromServerDialog
};
